(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stage-a-manual-j-header-offset"] && !Shopify.designMode) return;
  try {
    (() => {
    const calculator = document.querySelector('manual-j-flagship');
    const header = document.querySelector('.section-header');
    const result = calculator?.querySelector('[data-result]');
    if (!header || !result) return;

    let offset = 0;
    let aligned = false;
    let resizeFrame = 0;

    const measure = () => {
      const style = getComputedStyle(header);
      offset = ['sticky', 'fixed'].includes(style.position)
        ? header.getBoundingClientRect().height + (parseFloat(style.top) || 0)
        : 0;
      result.style.setProperty('--stage-a-result-header-offset', `${offset}px`);
    };

    const rememberAlignment = () => {
      if (resizeFrame) return;
      aligned = result.dataset.visible === 'true' &&
        Math.abs(result.getBoundingClientRect().top - offset) <= 1;
    };

    const resize = () => {
      const retainAlignment = aligned;
      measure();
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(() => {
        if (retainAlignment && result.dataset.visible === 'true') {
          result.scrollIntoView({ behavior: 'instant', block: 'start' });
        }
        resizeFrame = 0;
        rememberAlignment();
      });
    };

    measure();
    new ResizeObserver(resize).observe(header);
    window.addEventListener('resize', resize, { passive: true });
    window.addEventListener('scroll', rememberAlignment, { passive: true });
    calculator.addEventListener('mrcool:analytics', event => {
      if (event.detail?.event === 'manual_j_completed') measure();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
